export { InfoboxComponent, InfoboxButton, InfoboxType } from './infobox.component';
